
import { useState, useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import themePlugin from "@fullcalendar/react/themes/monarch"; // YOUR THEME
import dayGridPlugin from "@fullcalendar/react/daygrid";
import timeGridPlugin from '@fullcalendar/react/timegrid';
import interactionPlugin from '@fullcalendar/react/interaction';

// stylesheets
import '@fullcalendar/react/skeleton.css'; // ALWAYS NEED SKELETON
import '@fullcalendar/react/themes/monarch/theme.css'; // YOUR THEME
import '@fullcalendar/react/themes/monarch/palettes/purple.css'; // YOUR THEME'S PALETTE

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendar,
} from '@fortawesome/free-solid-svg-icons';

import Events from './Events';
import { COMMITMENT_TYPES } from "../../../constants/COMMITMENTS";

// import CommitmentFormModal from '../../admin/commitments/CommitmentFormModal';


// FUNÇÃO PARA MAPEAR REGISTROS DE COMPROMISSOS PARA O FORMATO DO FULLCALENDAR
export const mapearParaFullCalendar = (eventoOriginal) => {
  const dataInicio = `${eventoOriginal.date}T${eventoOriginal.time}`;
  const dataFim = `${eventoOriginal.end_date}T${eventoOriginal.end_time}`;

  const typeId = Number(eventoOriginal.commitment_type_id);
  const tipoConfig = COMMITMENT_TYPES[typeId] || {
    cor: '#3788d8',
    icon: faCalendar
  };

  return {
    id: String(eventoOriginal.id),
    title: eventoOriginal.title,
    start: dataInicio,
    end: dataFim,
    allDay: false,

    color: tipoConfig.color,
    backgroundColor: tipoConfig.color,
    borderColor: tipoConfig.color,
    textColor: '#ffffff',

    extendedProps: {
      commitment_type_id: eventoOriginal.commitment_type_id,
      description: eventoOriginal.description,
      priority: eventoOriginal.priority,
      status: eventoOriginal.status,
      completed: Boolean(eventoOriginal.completed),
      reference_type: eventoOriginal.reference_type,
      reference_id: eventoOriginal.reference_id,
      icon: tipoConfig.icon, // Guarda a referência direta do ícone React
      created: eventoOriginal.created,
      modified: eventoOriginal.modified
    }
  };
};

const renderEventContent = (eventInfo) => {
  const { icon } = eventInfo.event.extendedProps;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
      {/* Exibe o ícone caso exista */}
      {icon && <i className={icon} style={{ fontSize: '0.85em' }}></i>}

      {/* Horário (opcional, formatado pelo próprio FullCalendar) */}
      {eventInfo.timeText && <b>{eventInfo.timeText}</b>}

      {/* Título do evento */}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {eventInfo.event.title}
      </span>
    </div>
  );
};

const Calendar = ({ commitments = [] }) => {
  // Define o início do dia atual (00:00:00.000)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [currentEvents, setCurrentEvents] = useState([]);

  // CORREÇÃO: Usa a função correta de mapeamento em cima do array vindo por props
  // O useMemo memoriza o resultado e só recalcula se 'commitments' mudar de verdade
  const eventsData = useMemo(() => {
    return commitments.map(mapearParaFullCalendar);
  }, [commitments]);

  const filteredCommitments = useMemo(() => {
    return commitments.filter(item => {
      if (!item.date) return false;

      // Normaliza a data do compromisso para considerar apenas o dia
      const commitmentDate = new Date(item.date);
      commitmentDate.setHours(0, 0, 0, 0);

      return commitmentDate >= today;
    });
  }, [commitments]);

  const renderEventContent = (eventInfo) => {
    return (
      <small>
        <b>&nbsp;{eventInfo.timeText}</b>&nbsp;
        <i>{eventInfo.event.title}</i>
      </small>
    );
  };

  const handleWeekendsToggle = () => {
    setWeekendsVisible(!weekendsVisible);
  };

  const handleDateSelect = (selectInfo) => {
    let title = prompt('Please enter a new title for your event');
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect();

    if (title) {
      calendarApi.addEvent({
        id: String(Date.now()), // Gera um ID temporário único
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }
  };

  const handleEventClick = (clickInfo) => {
    if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      clickInfo.event.remove();
    }
  };

  const handleEvents = (events) => {
    setCurrentEvents(events);
  };

  return (
    <div className="card h-100">
      <div className="card-header bg-transparent">
        <div className="d-flex justify-content-between align-items-center">
          <strong>Calendário</strong>
        </div>
      </div>

      <div className="card-body">
        <FullCalendar
          plugins={[themePlugin, dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView='dayGridMonth'
          locale="pt-br"
          className="customCalendar"
          headerToolbar={{
            left: 'prev,next today adicionar',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay',
          }}

          buttons={{
            adicionar: {
              text: '+',
              click: function () {
                alert()
              }
            },
            today: {
              text: 'Hoje'
            },
            timeGridDay: {
              text: 'Dia'
            },
            timeGridWeek: {
              text: 'Semana'
            },
            dayGridMonth: {
              text: 'Mês'
            }
          }}

          editable={true}
          selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={weekendsVisible}

          // CORREÇÃO CRÍTICA: Mudado de initialEvents para events
          events={eventsData}

          select={handleDateSelect}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          eventsSet={handleEvents}
        />
      </div>

      <Events types={COMMITMENT_TYPES} commitments={filteredCommitments} />

      <div className="card-footer bg-transparent">
        <div className="d-flex flex-wrap gap-3 small text-muted">
          {Object.entries(COMMITMENT_TYPES).map(([id, tipo]) => (
            <small key={id} className="d-flex align-items-center gap-1">
              <FontAwesomeIcon icon={tipo.icon} style={{ color: tipo.color }} />
              {tipo.title}
            </small>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Calendar;